"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionState = exports.SectionContentType = void 0;
const base_model_1 = __importDefault(require("./base-model"));
const defaults_1 = require("./defaults");
const process_question_1 = __importDefault(require("./process-question"));
const video_1 = __importDefault(require("./video"));
var SectionContentType;
(function (SectionContentType) {
    SectionContentType["VIDEO"] = "VIDEO";
    SectionContentType["PROCESS_QUESTION"] = "PROCESS_QUESTION";
})(SectionContentType = exports.SectionContentType || (exports.SectionContentType = {}));
var SectionState;
(function (SectionState) {
    SectionState["INCOMPLETE"] = "INCOMPLETE";
    SectionState["COMPLETE"] = "COMPLETE";
})(SectionState = exports.SectionState || (exports.SectionState = {}));
function isSectionContent(v) {
    return Object.prototype.hasOwnProperty.call(v, 'content_type') && Object.prototype.hasOwnProperty.call(v, 'data');
}
function isVideo(v) {
    return v.content_type === SectionContentType.VIDEO;
}
function isProcessQuestion(v) {
    return v.content_type === SectionContentType.PROCESS_QUESTION;
}
class Section extends base_model_1.default {
    constructor(data = {
        id: null,
        name: null,
        order: null,
        contents: null,
        next: null,
        previous: null,
        state: null
    }) {
        super(data);
        this.name = defaults_1.defaultString(data.name);
        this.order = defaults_1.defaultNumber(data.order);
        this.next = defaults_1.defaultString(data.next);
        this.previous = defaults_1.defaultString(data.previous);
        this.state = defaults_1.defaultEnum(data.state, SectionState);
        this.entities = {
            videos: {},
            processquestions: {},
        };
        this.contents = defaults_1.defaultArray(data.contents).map((v) => {
            let d = v;
            if (isSectionContent(v) && isVideo(v)) {
                d = new video_1.default({ ...v.data, next: v.next, previous: v.previous });
            }
            if (isSectionContent(v) && isProcessQuestion(v)) {
                d = new process_question_1.default({ ...v.data, next: v.next, previous: v.previous });
            }
            return d;
        });
    }
    get data() {
        return this.videos.map((v) => this.entities.videos[v.id]).sort((a, b) => a.order - b.order);
    }
    get processQuestion() {
        if (this.entities.processquestions) {
            return Object.values(this.entities.processquestions)[0];
        }
        return undefined;
    }
    get videos() {
        return this.contents.filter(({ schema }) => schema === 'videos');
    }
    get videosCompleted() {
        return this.videosTotal === this.videosCompletedTotal;
    }
    get processQuestionCompleted() {
        var _a;
        return !!((_a = this.processQuestion) === null || _a === void 0 ? void 0 : _a.completed);
    }
    get videosCompletedTotal() {
        return this.videos.filter((video) => { var _a, _b; return ((_a = this.entities.videos[video.id]) === null || _a === void 0 ? void 0 : _a.state) === ((_b = this.entities.videos[video.id]) === null || _b === void 0 ? void 0 : _b.VideoState.COMPLETE); }).length;
    }
    get videosTotal() {
        return this.videos.length;
    }
    get completed() {
        return this.videosCompleted && this.processQuestionCompleted;
    }
}
exports.default = Section;
